// src/pages/Home.js
import React from "react";
import Banner from "../components/Playables/Banner/Banner";
import Industries from "../components/Playables/Industries/Industries";
import GameCategories from "../components/Playables/GameCategories/GameCategories";
import CaseStudy from "../components/Playables/Case Study/casestudy";
import Analytics from "../components/Playables/Analytics/Analytics";

export default function Home() {
    return (
        <>
            <Banner/>
            <Industries/>
            <GameCategories/>
            <CaseStudy/>
            <Analytics/>
        </>
    );
}